class QuickAddModal extends HTMLElement {
  constructor() {
    super();

    // Bind methods
    this.open = this.open.bind(this);
    this.close = this.close.bind(this);
    this.boundToCartForm = this.boundToCartForm.bind(this);

    // Initialize properties
    this.cartForm = null;
  }

  connectedCallback() {
    const trigger = this.querySelector('[js-modal-trigger]');
    if (trigger) {
      trigger.addEventListener('click', (e) => {
        e.stopPropagation();
        this.open();

        const selector = e.target.dataset.selector;
        const modalVariantPicker = document.querySelector(`.js-pop-up-modal[data-selector="${selector}"]`)

        if (!modalVariantPicker) return
        modalVariantPicker.classList.add('open')
      });
    }

    const closeBtns = this.querySelectorAll('[js-close-btn]');

    closeBtns.forEach((closeBtn) => {
      closeBtn.addEventListener('click', this.close);
    });

    const closeBackdrop = this.querySelector('[ js-modal-backdrop]');

    if (closeBackdrop) closeBackdrop.addEventListener('click', this.close);

    window.addEventListener('keyup', (evt) => {
      if (evt.code === 'Escape') this.close();
    });
  }

  open() {
    this.classList.add('open');
    document.body.classList.add('overflow-hidden');
    this.cartForm?.addEventListener('cart-form-submit', this.close);
  }

  close() {
    this.classList.add('closing');
    this.cartForm?.removeEventListener?.('cart-form-submit', this.close);
    setTimeout(() => {
      this.classList.remove('open');
      this.classList.remove('closing');
      document.body.classList.remove('overflow-hidden');
    }, 300);
  }

  boundToCartForm(cartForm) {
    this.cartForm = cartForm;
    const variantPickerModal = this.querySelector('variant-picker-modal');
    if (variantPickerModal) {
      variantPickerModal.boundToCartForm(this.cartForm);
    }
  }
}

if (!customElements.get('quick-add-modal')) {
  customElements.define('quick-add-modal', QuickAddModal);
}
